import { render, staticRenderFns } from "./CaricaFileNotaCredito.vue?vue&type=template&id=106cd41b&scoped=true&"
import script from "./CaricaFileNotaCredito.vue?vue&type=script&lang=js&"
export * from "./CaricaFileNotaCredito.vue?vue&type=script&lang=js&"
import style0 from "./CaricaFileNotaCredito.vue?vue&type=style&index=0&id=106cd41b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cd41b",
  null
  
)

export default component.exports